import { Box, Button, Dialog, FormControlLabel, makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";

interface Props {
  open: boolean;
  onPricingChangeSaved: (pricingChangeInPercents: number) => void;
  onCancel: () => void;
}

const useStyles = makeStyles(theme => ({
  inputControl: {
    marginRight: 0
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3)
  },
  button: {
    marginTop: theme.spacing(1)
  },
  label: {
    width: 200,
    margin: theme.spacing(1)
  },
  priceChangeInput: {
    width: 100
  }
}));

const PricingBulkUpdateDialog = (props: Props) => {
  const classes = useStyles();
  const [priceChangeInPercents, setPriceChangeInPercents] = useState<string>();
  
  const handlePriceChangeInPercentsChanged = (priceChangeInPercents: string) => {
    setPriceChangeInPercents(priceChangeInPercents);
  };

  const handlePricingChangeSaveButtonClicked = () => {
    if (priceChangeInPercents) {
      const priceChangeInPercentsAsNumber = parseFloat(priceChangeInPercents);
      if (isNaN(priceChangeInPercentsAsNumber)) {
        console.debug(`Price change in percents is not a number: ${priceChangeInPercents}`);
      } else {
        props.onPricingChangeSaved(priceChangeInPercentsAsNumber);
      }
    } else {
      console.debug(`Price change in percents was not provided: ${priceChangeInPercents}`);
    }
  }

  return (
    <Dialog open={props.open}>
      <Box className={classes.dialogContent}>
        <Box display='flex' flexDirection='row'>
          <FormControlLabel
            classes={({
              root: classes.inputControl,
              label: classes.label
            })}
            label='Procentowa zmiana ceny materiału:'
            control={
              <TextField
                type='number'
                variant='outlined'
                className={classes.priceChangeInput}
                onChange={event => handlePriceChangeInPercentsChanged(event.target.value)}
                value={priceChangeInPercents}
              />
            }
            labelPlacement='start'
          />
        </Box>
        <Button
          color='primary'
          className={classes.button}
          onClick={handlePricingChangeSaveButtonClicked}
          variant='contained'>
            Zapisz i zamknij
        </Button>
        <Button
          color='secondary'
          className={classes.button}
          onClick={props.onCancel}
          variant='contained'>
            Anuluj wprowadzanie
        </Button>
      </Box>
    </Dialog>
  );
};

export default PricingBulkUpdateDialog;